var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5CA3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.2,110c-7-3.1-15.1-7.2-16-8.4c-0.9-1.3-1.4-4.9-1.5-7.4c5.8-3.9,8.9-8.7,10.6-13 c1.8-0.4,5.5-1.6,6.5-5.7c0.5-2.4-0.1-3.8-0.8-4.7c-0.2-0.2-0.4-0.4-0.6-0.6c1.9-4.6,6.9-19.3-3.9-27.2 C86,35.6,77.8,39.2,75,40.8C71.7,39,61,34.5,48.1,45.8c-14.4,12.6-6,33.2,1.2,43.5c4.9,6.9,0.6,17.9-0.5,20.4 c-0.3,0.1-0.5,0.2-0.8,0.4c-0.8,0.4-1.2,1.3-0.8,2.2c0.3,0.6,0.9,1,1.5,1c0.2,0,0.4,0,0.7-0.1c4.7-2.1,15.8-7.1,17.5-9.6 c1.1-1.7,1.7-4.9,1.9-7.2c1.4,0.7,3,1.4,4.6,2v13.3c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6V98.2c1.8-0.7,3.4-1.4,4.9-2.2 c0.2,2.3,0.8,5.6,1.9,7.3c1.7,2.5,12.8,7.5,17.5,9.6c0.2,0.1,0.4,0.1,0.7,0.1c0.6,0,1.2-0.4,1.5-1 C103.4,111.3,103.1,110.4,102.2,110z M98.5,74.8c-0.3,1.3-1.2,2.1-2.1,2.5c0.5-2,0.6-3.7,0.6-5l0,0c0,0,0.9,0,1.3,0.5 C98.7,73.4,98.6,74.2,98.5,74.8z M76.6,43.7c2-1.3,8.8-4.4,17.8,2.1c9,6.5,4.4,19.5,2.8,23.3c0,0-0.1,0-0.1,0 c-14.7-1.2-19.9-13.8-20.5-15.7V43.7z M64.1,101.6c-0.7,1-5.6,3.6-11,6.1c1.7-5,3.5-13.8-1.1-20.3c-6.6-9.3-14.4-28-1.7-39.1 c11.6-10.2,20.6-6,23-4.6v9.7c-0.7,1.8-5.9,14.5-20.5,15.7c-0.5,0-2.5,0.2-3.8,1.8c-0.6,0.8-1.3,2.3-0.8,4.7 c0.9,4,4.6,5.3,6.5,5.7c1.7,4.3,4.8,9.2,10.9,13.2C65.4,96.8,64.9,100.3,64.1,101.6z M53.5,77.4c-0.9-0.5-1.8-1.3-2.1-2.5 c-0.1-0.6-0.2-1.4,0.1-1.9c0.3-0.4,1.1-0.5,1.3-0.5l0,0C52.9,73.6,53.1,75.3,53.5,77.4z M57.4,79.5c0-0.2-0.1-0.4-0.2-0.5 c-1-3-1.1-5.6-1.1-7c8.8-1.7,14.2-7.2,17.2-11.6v25.9h-1.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h1.2v6.4 C63.5,90.8,59.3,84.6,57.4,79.5z M76.6,94.7v-6.3h1.3c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.3V60.3 c3,4.4,8.4,9.9,17.2,11.6C93.8,75.7,92.6,88.4,76.6,94.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.7,73.7c-0.1-0.1-1.6-0.9-3.6-0.9c-1,0-2.2,0.2-3.4,0.9c-0.5,0.3-0.7,0.9-0.4,1.5 c0.3,0.5,0.9,0.7,1.5,0.4c2.4-1.4,4.8-0.1,4.9,0c0.5,0.3,1.2,0.1,1.4-0.4C86.4,74.6,86.3,74,85.7,73.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.7,73.7c-0.1-0.1-1.6-0.9-3.6-0.9c-1,0-2.2,0.2-3.4,0.9c-0.5,0.3-0.7,0.9-0.4,1.5 c0.3,0.5,0.9,0.7,1.5,0.4c2.4-1.4,4.8-0.1,4.9,0c0.5,0.3,1.2,0.1,1.4-0.4C71.4,74.6,71.2,74,70.7,73.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,92.1c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C47.3,96.4,45.7,94.5,45.7,92.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.8,29.8c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C77.4,34.1,75.8,32.2,75.8,29.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.5,87c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C102.1,91.3,100.5,89.4,100.5,87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.8,98.3c0,0.7-0.6,1.3-1.4,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C93.2,97,93.8,97.6,93.8,98.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 49.3,
    cy: 37.3,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 40.2,
    cy: 86.3,
    r: 1.4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/Gemini.a5c9e325e7b185505aa097dc62236ef1.svg";
export { ForwardRef as ReactComponent };